<template lang="pug">
el-dialog#resultado-diagnostico-fornecedor(
    :title='`${dados.nome} (${dados.documento})`',
    :visible.sync='mostrar',
    :destroy-on-close='true',
    :before-close='fechar'
)
    DiagnosticoSocioambiental(
        :dadosConsulta='{ diagnosticos: dados.analise }',
        :cpfCnpj='dados.documento',
        :habilitar-sinal-aviso='true'
    )
</template>

<script>
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';

export default {
    name: 'ModalResultadoDiagnosticoFornecedor',

    components: {
        DiagnosticoSocioambiental
    },

    props: {
        dados: {
            required: true,
            type: Object
        },

        mostrar: {
            required: true,
            type: Boolean
        }
    },

    watch: {
        dados: function () {
            if (this.dados) {
                this.dados.analise.sort((a, b) => {
                    return a.camada.nome.localeCompare(b.camada.nome);
                });
            }
        }
    },

    methods: {
        fechar() {
            this.$emit('fechar');
        }
    }
};
</script>
